import {IItemContent, ItemFactory} from "@connox/typescript-library";
import React, {Suspense, useEffect, useState} from "react";
import ReactDOM from "react-dom";
import ItemsList from "./ItemsList";
import window from "../lib/WindowExtended";
import {getShopId} from "../lib/getShopId";

const ProductSeriesPortal: React.FC = () => {
  const parentCategoriesElement = document.getElementById("ParentCategoryProductsContainer");
  const categoryId = Number(parentCategoriesElement?.dataset.parentCategoryId ?? "0");
  const parentName = String(parentCategoriesElement?.dataset.name);
  const url = String(parentCategoriesElement?.dataset.categoryUrl);
  const limit = Number(parentCategoriesElement?.dataset.limit ?? "0");
  const currencyCode: string = window.c_ActiveCurrency;
  const [items, setItems] = useState<IItemContent[]>([]);

  useEffect(() => {
    if (parentCategoriesElement) {
      void ItemFactory.getItems(getShopId(), {currencyCode, categoryId, limit}).then((data) => {
        setItems(data.itemContent);
      });
    }
  }, []);

  if (!items.length || !parentCategoriesElement) {
    return null;
  }

  return ReactDOM.createPortal(
    <Suspense fallback={null}>
      <ItemsList name={parentName} url={url} items={items} swipeable={true} />
    </Suspense>,
    parentCategoriesElement,
  );
};

export default ProductSeriesPortal;
